import { NOTIFICATION_HISTORY } from "actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  selectedData: null,
  formType: "",
  formId: "",
  formTitle: ""
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case NOTIFICATION_HISTORY:
    if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
      action.payload = {...initialState};
    }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/NotificationHistory.js